import React from 'react';
import Page from '../components/Page';
import WorkflowSection from '../components/WorkflowSection';
import HeroSection from '../components/HeroSection';
import InfoColumnSection from '../components/InfoColumnSection';
import TeamSection from '../components/TeamSection';
import FriendsSection from '../components/FriendsSection';
import AboutUsSection from '../components/AboutUsSection';
import { wearePage } from '../data';
import variables from '../styles/variables.module.scss';

const WeArePage = () => (
  <Page
    offset
    style={{ backgroundColor: variables.tuna }}
  >
    <HeroSection
      title={wearePage.heroTitle}
      stroke={wearePage.heroStroke}
      strokeColor={variables.cleanWhite}
      headline={wearePage.heroHeadline}
      backgroundColor={variables.tuna}
      firstSideHeading={wearePage.heroFirstSideHeading}
      secondSideHeading={wearePage.heroSecondSideHeading}
      offset
    />
    <AboutUsSection />
    <InfoColumnSection
      headlineSmall={wearePage.infoColSmall}
      headlineLarge={wearePage.infoColLarge}
      stroke={wearePage.infoColStroke}
      title={wearePage.infoColTitle}
      body={wearePage.infoColBody}
      data={wearePage.infoColData}
    />
    <WorkflowSection />
    <TeamSection />
    <FriendsSection />
  </Page>
);

export default WeArePage;
